module.exports = __webpack_public_path__ + "img/intelligence.d6ce603.png";